export default __webpack_public_path__ + "static/media/img-check-on.8286aa8d.svg";